import { Component } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Container, Segment, Sidebar } from 'semantic-ui-react';

import FooterNavigation from '../../navigation/components/FooterNavigation';
import MobileNavigation from '../../navigation/components/MobileNavigation';

class MobileContainer extends Component {
  state = {};

  handlePusherClick = () => {
    const { sidebarOpened } = this.state;

    if (sidebarOpened) this.setState({ sidebarOpened: false });
  };

  handleToggle = () => this.setState({ sidebarOpened: !this.state.sidebarOpened });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    // No Sidebar here; Semantic's Pushable transform would make fixed children measure against the page, not the screen.
    return (
      <Sidebar.Pushable as={Segment} style={{ transform: 'none' }}>
        <Sidebar.Pusher dimmed={sidebarOpened} onClick={this.handlePusherClick} className="mobile-container">
          <Segment vertical className="navbar no-padding">
            <Container className="no-padding no-margin">
              <MobileNavigation handleToggle={this.handleToggle} />
            </Container>
          </Segment>

          <main id="content">{children}</main>

          <FooterNavigation viewport="mobile" />
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}
export default MobileContainer;
